import {
  SectionMessage,
  SelectFormikField,
  SelectItem,
} from "@certn/cascadia-react";

import { Link, Stack, Text } from "@certn/cascadia";
import { useTranslation } from "react-i18next";

import { PreviewRubricModal } from "../../../../../../components/preview-adjudication-rubric/PreviewRubricModal";
import { APIError, useClientPortalAPI } from "@certn/api";

export function SelectExistingRubricSection({
  response,
  rubric_id,
}: {
  response: ReturnType<
    typeof useClientPortalAPI<"/api/internal/client-portal/adjudication-rubrics/filter-by-check-type/">
  >;
  rubric_id: string | null;
}) {
  const { t } = useTranslation();

  const selectedRubric =
    response.data?.find((rubric) => rubric.id === rubric_id) ?? null;

  return (
    <>
      <Stack gap="space-4">
        <Text style="global/heading-medium">{t("Apply a rubric")}</Text>
        <SelectFormikField
          name="rubric_id"
          label={t("Scoring rubric")}
          isRequired
          isDisabled={!response.data?.length}
          testID={"scoring-rubric-select"}
          info={
            selectedRubric && (
              <PreviewRubricModal
                rulesets={selectedRubric.rulesets.map((ruleset) => ({
                  id: ruleset.id,
                  check_type: ruleset.check_type,
                  criteria: ruleset.criteria,
                }))}
              />
            )
          }
        >
          {response.data?.map((rubric) => (
            <SelectItem id={rubric.id} key={rubric.id}>
              {rubric.name}
            </SelectItem>
          ))}
        </SelectFormikField>
        {!response.data?.length && (
          <>
            {response.error &&
            response.error instanceof APIError &&
            response.error.status === 403 ? (
              <SectionMessage
                type="info"
                sectionTitle={t(
                  "No permissions - Unable to select scoring rubric"
                )}
                icon="info"
              >
                {t("Please click 'Next step'")}
              </SectionMessage>
            ) : (
              <SectionMessage
                type="default"
                sectionTitle={t("No rubrics available")}
                icon="info"
              >
                <Text style="global/body-secondary">
                  {t("No rubrics available. Create one in the")}
                </Text>{" "}
                <Link
                  textColor="text-base"
                  testID="adjudication-link"
                  href="/adjudication"
                >
                  {t("Scoring Rules page")}
                </Link>{" "}
                <Text style="global/body-secondary">
                  {t("to customise how results are scored.")}
                </Text>
              </SectionMessage>
            )}
          </>
        )}
      </Stack>
    </>
  );
}
